import { render, staticRenderFns } from "./BITenders.vue?vue&type=template&id=43d9faa9"
import script from "./BITenders.vue?vue&type=script&lang=js"
export * from "./BITenders.vue?vue&type=script&lang=js"
import style0 from "./BITenders.vue?vue&type=style&index=0&id=43d9faa9&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports